import axios from 'axios'
import { API_KEY, API_URL, CUSTOMERS_KEY } from '../keys'
import CustomersEntity from '@/entities/api/customers/customers'

export const createCustomer = async (
	customerData: Partial<CustomersEntity>,
	imageFiles: File[]
) => {
	const formData = new FormData()
	formData.append('customerData', JSON.stringify(customerData))
	imageFiles.forEach((file) => {
		formData.append('files', file)
	})

	const response = await axios.post(`${API_URL}/customers`, formData, {
		headers: {
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'multipart/form-data',
		},
		validateStatus: (status) => status < 500,
	})

	if (response) return response
}

export const fetchCustomers = async (
	token: string,
	limit: number,
	offset: number
) => {
	const params: Record<string, any> = {}
	params.limit = limit
	params.offset = offset

	const response = await axios.get(`${API_URL}/customers`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		params,
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const updateCustomerById = async (
	token: string,
	id: string,
	customerData: Partial<CustomersEntity>
) => {
	const response = await axios.patch(
		`${API_URL}/customers/${id}`,
		customerData,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-key': CUSTOMERS_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	if (response) return response
}

export const removeCustomerById = async (token: string, id: string) => {
	const response = await axios.delete(`${API_URL}/customers/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
